let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jwtoD")).then(() => parcelRequire('15j5l'));